module.exports = __webpack_public_path__ + "img/Thailand.9044e545.svg";